import React from 'react';
export function Footer() {
  return <footer className="bg-brand-black py-12 border-t border-brand-gold/20" data-id="element-70">
      <div className="max-w-7xl mx-auto px-6 flex flex-col items-center" data-id="element-71">
        <div className="w-32 mb-8 opacity-80 hover:opacity-100 transition-opacity duration-300" data-id="element-72">
          <img src="https://cdn.magicpatterns.com/uploads/whGaC1sRHyfLjnFDgPVh9C/IMG_20260429_142945.png" alt="Grill 211 Restaurant" className="w-full h-auto mix-blend-screen" data-id="element-73" />
        </div>

        <div className="flex space-x-6 mb-8" data-id="element-74">
          <a href="#" className="text-brand-offwhite/50 hover:text-brand-gold transition-colors duration-300 uppercase tracking-widest text-xs" data-id="element-75">
            Instagram
          </a>
          <a href="#" className="text-brand-offwhite/50 hover:text-brand-gold transition-colors duration-300 uppercase tracking-widest text-xs" data-id="element-76">
            Facebook
          </a>
        </div>

        <p className="text-brand-offwhite/40 text-xs tracking-wider text-center" data-id="element-77">
          &copy; {new Date().getFullYear()} Grill 211. All rights reserved.
          <br className="md:hidden" data-id="element-78" /> 211 Broadway, Paducah, KY.
        </p>
      </div>
    </footer>;
}